import React from 'react';
import { Info, Building2, Users, FileText, BookOpen, ShieldCheck } from 'lucide-react';

export default function AcercaPage() {
  const version = `V.1.${String(new Date().getFullYear()).slice(2)}.${String(new Date().getMonth() + 1).toString().padStart(2, '0')}.${String(new Date().getDate()).toString().padStart(2, '0')}`;

  return (
    <div className="min-h-screen bg-gradient-to-tr from-blue-50 via-white to-[#e3eaf6] flex flex-col items-center py-10 px-2">
      {/* Card Central */}
      <div className="w-full max-w-3xl bg-white rounded-3xl shadow-2xl border border-gray-200 p-7 sm:p-10 space-y-6">
        {/* Header */}
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-[#003865]/10 rounded-full p-3">
            <Info className="w-8 h-8 text-[#003865]" />
          </div>
          <h1 className="text-2xl sm:text-3xl font-black text-[#003865] tracking-tight">
            Acerca del Portal Fedelza
          </h1>
        </div>

        {/* Secciones */}
        <div className="space-y-5">
          {/* Nombre del sistema */}
          <section className="flex items-center gap-3">
            <FileText className="w-5 h-5 text-blue-800 opacity-80" />
            <div>
              <h2 className="text-lg font-bold text-blue-900">Nombre del sistema</h2>
              <p className="text-sm text-gray-700">Portal de Facturación Electrónica – Fedelza</p>
            </div>
          </section>
          {/* Descripción general */}
          <section className="flex items-center gap-3">
            <BookOpen className="w-5 h-5 text-blue-800 opacity-80" />
            <div>
              <h2 className="text-lg font-bold text-blue-900">Descripción general</h2>
              <p className="text-sm text-gray-700">
                Plataforma que permite emitir, consultar y gestionar documentos electrónicos (facturas, notas crédito, documentos soporte), cumpliendo con la DIAN, de manera ágil y segura.
              </p>
            </div>
          </section>
          {/* Información de la empresa */}
          <section className="flex items-center gap-3">
            <Building2 className="w-5 h-5 text-blue-800 opacity-80" />
            <div>
              <h2 className="text-lg font-bold text-blue-900">Información de la empresa</h2>
              <p className="text-sm text-gray-800">Empresa: <span className="font-semibold text-[#003865]">FEDELZA SAS</span></p>
              <p className="text-sm text-gray-800">NIT: <span className="font-mono">901.188.189-9</span></p>
              <p className="text-sm text-gray-800">Ubicación: Medellín, Colombia</p>
              <p className="text-sm text-gray-800">Correo de contacto: <a href="mailto:crm@fedelza.com" className="underline hover:text-blue-700">crm@fedelza.com</a></p>
            </div>
          </section>
          {/* Historia breve */}
          <section className="flex items-center gap-3">
            <Users className="w-5 h-5 text-blue-800 opacity-80" />
            <div>
              <h2 className="text-lg font-bold text-blue-900">Historia breve</h2>
              <p className="text-sm text-gray-700">
                El Portal Fedelza nació para facilitar la facturación electrónica a las empresas colombianas, permitiendo cumplimiento normativo y automatización. Pensado para pymes y medianas, es robusto, amigable y evoluciona con la normativa.
              </p>
            </div>
          </section>
          {/* Equipo */}
          <section className="flex items-center gap-3">
            <Users className="w-5 h-5 text-blue-800 opacity-80" />
            <div>
              <h2 className="text-lg font-bold text-blue-900">Equipo</h2>
              <p className="text-sm text-gray-700">
                Desarrollado por el equipo de tecnología de Fedelza, comprometidos con soluciones confiables y adaptadas a tus necesidades.
              </p>
            </div>
          </section>
          {/* Términos de uso */}
          <section className="flex items-center gap-3">
            <ShieldCheck className="w-5 h-5 text-blue-800 opacity-80" />
            <div>
              <h2 className="text-lg font-bold text-blue-900">Términos de uso</h2>
              <p className="text-sm text-gray-700">
                El sistema es propiedad de FEDELZA SAS. Uso restringido a clientes autorizados. Prohibida su reproducción parcial o total sin autorización expresa.
              </p>
            </div>
          </section>
        </div>

        {/* Footer de versión */}
        <div className="mt-8 pt-4 border-t border-dashed border-gray-200 text-right">
          <span className="text-xs text-gray-400">Versión actual:</span>
          <span className="ml-2 text-sm font-semibold text-[#003865]">{version}</span>
        </div>
      </div>
    </div>
  );
}
